// extracted by mini-css-extract-plugin
module.exports = {"replacement":"ReplacementPersonView_replacement__3DjcP","modal_heading":"ReplacementPersonView_modal_heading__3Nfza","employee":"ReplacementPersonView_employee__3Cri0"};